import styled from "styled-components";

export const ToastWrapper = styled.div`
    .Toastify__toast {
        top: 70px !important;
    }
    .Toastify{
        z-index: 9999999 !important;
    }
`
